import { AlertTriangle } from "lucide-react";

export const TechnicalDisclaimer = () => (
  <div
    data-testid="technical-disclaimer"
    className="border border-brand-line bg-white p-6"
  >
    <div className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-brand-red">
      <AlertTriangle className="h-4 w-4" /> Technical Disclaimer
    </div>
    <p className="text-sm leading-relaxed text-brand-muted">
      MATRIVON technical content and calculators are educational and analytical tools only. They are
      not a substitute for laboratory validation, production trials, supplier technical data, SDS
      review, regulatory compliance or qualified engineering judgement. Formulation performance
      depends on actual raw-material specifications and process conditions.
    </p>
  </div>
);
